import React from 'react';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      text: "Talking to Krishna helped me find calm during stressful days.",
      author: "Priya S.",
      location: "Mumbai"
    },
    {
      text: "I feel like I have a spiritual guide in my pocket.",
      author: "Rahul M.",
      location: "Delhi"
    },
    {
      text: "This app made spirituality easier to understand.",
      author: "Anjali K.",
      location: "Bangalore"
    }
  ];

  return (
    <section className="py-20 relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4 text-white">
            What People Are <span className="text-gradient">Experiencing</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Real stories from spiritual seekers like you
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="divine-card p-8 hover:scale-105 transition-all duration-300"
            >
              <Quote className="w-10 h-10 text-orange-500 mb-4" />
              <p className="text-gray-200 text-lg mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              <div className="border-t border-white/10 pt-4">
                <p className="text-white font-semibold">{testimonial.author}</p>
                <p className="text-gray-400 text-sm">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;